 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-analytics":"admin-analytics","admin-auth~clip-delivery~legacy-snapshot-flow~registration-flow~snapshot-flow~store-checkout":"admin-auth~clip-delivery~legacy-snapshot-flow~registration-flow~snapshot-flow~store-checkout","admin-auth":"admin-auth","admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor":"admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor","legacy-snapshot-flow":"legacy-snapshot-flow","clip-delivery~registration-flow~store-checkout":"clip-delivery~registration-flow~store-checkout","clip-delivery~registration-flow":"clip-delivery~registration-flow","clip-delivery":"clip-delivery","registration-flow":"registration-flow","store-checkout":"store-checkout","snapshot-flow":"snapshot-flow","admin-ceremony-search":"admin-ceremony-search","admin-source-inputs":"admin-source-inputs","admin-upload":"admin-upload","submission-editor":"submission-editor","admin-clips":"admin-clips","admin-imports":"admin-imports","admin-messaging":"admin-messaging","admin-shell":"admin-shell","admin-snapshot":"admin-snapshot","admin-support":"admin-support","admin-users":"admin-users","digital-download-delivery":"digital-download-delivery","static-pages":"static-pages","store-flow":"store-flow","submission-auto-accept":"submission-auto-accept","submission-help":"submission-help"}[chunkId]||chunkId) + "." + {"admin-analytics":"466cc997","admin-auth~clip-delivery~legacy-snapshot-flow~registration-flow~snapshot-flow~store-checkout":"f8582c29","admin-auth":"0df81731","admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor":"4eb5bd5d","legacy-snapshot-flow":"0a1c00b9","clip-delivery~registration-flow~store-checkout":"d18eb95d","clip-delivery~registration-flow":"21331e93","clip-delivery":"d0240c25","registration-flow":"3dcca22f","store-checkout":"8d719c5a","snapshot-flow":"0b67ac16","admin-ceremony-search":"af027593","admin-source-inputs":"9c7501f8","admin-upload":"ca5c930d","submission-editor":"4a803e00","admin-clips":"7f631414","admin-imports":"1da62571","admin-messaging":"18e9d488","admin-shell":"795a131f","admin-snapshot":"5a7969d4","admin-support":"7d15bae5","admin-users":"85546013","digital-download-delivery":"9461594f","static-pages":"18ccd077","store-flow":"9b5d3cf7","submission-auto-accept":"14c69c3c","submission-help":"bc9f17db"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-analytics":1,"admin-auth":1,"admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor":1,"legacy-snapshot-flow":1,"clip-delivery~registration-flow":1,"clip-delivery":1,"registration-flow":1,"store-checkout":1,"snapshot-flow":1,"admin-ceremony-search":1,"admin-upload":1,"submission-editor":1,"admin-imports":1,"admin-messaging":1,"admin-shell":1,"admin-snapshot":1,"admin-support":1,"static-pages":1,"submission-help":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-analytics":"admin-analytics","admin-auth~clip-delivery~legacy-snapshot-flow~registration-flow~snapshot-flow~store-checkout":"admin-auth~clip-delivery~legacy-snapshot-flow~registration-flow~snapshot-flow~store-checkout","admin-auth":"admin-auth","admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor":"admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor","legacy-snapshot-flow":"legacy-snapshot-flow","clip-delivery~registration-flow~store-checkout":"clip-delivery~registration-flow~store-checkout","clip-delivery~registration-flow":"clip-delivery~registration-flow","clip-delivery":"clip-delivery","registration-flow":"registration-flow","store-checkout":"store-checkout","snapshot-flow":"snapshot-flow","admin-ceremony-search":"admin-ceremony-search","admin-source-inputs":"admin-source-inputs","admin-upload":"admin-upload","submission-editor":"submission-editor","admin-clips":"admin-clips","admin-imports":"admin-imports","admin-messaging":"admin-messaging","admin-shell":"admin-shell","admin-snapshot":"admin-snapshot","admin-support":"admin-support","admin-users":"admin-users","digital-download-delivery":"digital-download-delivery","static-pages":"static-pages","store-flow":"store-flow","submission-auto-accept":"submission-auto-accept","submission-help":"submission-help"}[chunkId]||chunkId) + "." + {"admin-analytics":"238ed091","admin-auth~clip-delivery~legacy-snapshot-flow~registration-flow~snapshot-flow~store-checkout":"31d6cfe0","admin-auth":"74694936","admin-ceremony-search~admin-source-inputs~admin-upload~legacy-snapshot-flow~submission-editor":"05187326","legacy-snapshot-flow":"8fd80023","clip-delivery~registration-flow~store-checkout":"31d6cfe0","clip-delivery~registration-flow":"fc6a7b1b","clip-delivery":"55d8c882","registration-flow":"4f19de54","store-checkout":"7fa35796","snapshot-flow":"768bc588","admin-ceremony-search":"e4097d7b","admin-source-inputs":"31d6cfe0","admin-upload":"a9d51a34","submission-editor":"03831fe9","admin-clips":"31d6cfe0","admin-imports":"8de63df0","admin-messaging":"a67df048","admin-shell":"7485a6c8","admin-snapshot":"b63b2b2f","admin-support":"23bbbc38","admin-users":"31d6cfe0","digital-download-delivery":"31d6cfe0","static-pages":"4ef8b4b1","store-flow":"31d6cfe0","submission-auto-accept":"31d6cfe0","submission-help":"0a4ded0d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
